import { render, staticRenderFns } from "./material-content.vue?vue&type=template&id=05f378a8&scoped=true"
import script from "./material-content.vue?vue&type=script&setup=true&lang=js"
export * from "./material-content.vue?vue&type=script&setup=true&lang=js"
import style0 from "./material-content.vue?vue&type=style&index=0&id=05f378a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f378a8",
  null
  
)

export default component.exports